module.exports = __webpack_public_path__ + "static/media/access.db78450e.png";